import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { loginWithGoogleSession } from '../../services/api';
import { Spinner, Container, Alert } from 'react-bootstrap';

const OAuthSuccess = () => {
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const handleLogin = async () => {
      try {
        console.log('Đang xử lý đăng nhập Google trong component OAuthSuccess');
        setLoading(true);
        
        // Gọi API để lấy thông tin user và token
        const response = await loginWithGoogleSession();
        
        // Kiểm tra kết quả
        if (response && response.accessToken) {
          console.log('Đăng nhập Google thành công, chuyển hướng đến trang chủ');
          navigate('/');
        } else {
          console.error('Đăng nhập Google thất bại: không nhận được token');
          setError('Không nhận được token xác thực từ server');
          setTimeout(() => navigate('/login'), 3000);
        }
      } catch (error) {
        console.error('Lỗi khi xác thực phiên đăng nhập Google:', error);
        setError(error.message || 'Lỗi không xác định khi đăng nhập');
        setTimeout(() => navigate('/login'), 3000);
      } finally {
        setLoading(false);
      }
    };

    handleLogin();
  }, [navigate]);

  return (
    <Container className="d-flex flex-column justify-content-center align-items-center" style={{ height: '80vh' }}>
      {loading ? (
        <div className="text-center">
          <Spinner animation="border" variant="primary" />
          <p className="mt-3">Đang xác thực Google... vui lòng chờ</p>
        </div>
      ) : error ? (
        <Alert variant="danger">
          <Alert.Heading>Đăng nhập thất bại</Alert.Heading>
          <p>{error}</p>
          <p>Đang chuyển hướng về trang đăng nhập...</p>
        </Alert>
      ) : (
        <div className="text-center">
          <Spinner animation="border" variant="success" />
          <p className="mt-3">Đăng nhập thành công! Đang chuyển hướng...</p>
        </div>
      )}
    </Container>
  );
};

export default OAuthSuccess;